<template>
  <v-app>
    <v-main class="mb-16">
      <Header
        :title="translatedTitle"
        :title-only="!backButton"
        :backButton="backButton"
      />
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/layouts/shared/Header";
import Tabs from "@/layouts/shared/Tabs";
import i18n from "@/services/i18n";

export default {
  i18n: i18n,
  components: {
    Header,
    Tabs
  },
  name: "restricted-layout",
  props: ["title"],

  data() {
    return {
      path: window.location.pathname,
    };
  },

  computed: {
    translatedTitle() {
      return this.$t('pageTitle.'+this.title.toLowerCase())
    },
    backButton() {
      if (
        this.path === "/Unauthorized"
      ) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    /*    this.$i18n.locale = this.$store.getters.user.language;

        if (this.$store.getters.user.language){
          if (this.$store.getters.user.language === "be") {
            this.$moment.locale("nl-be")
          } else {
            this.$moment.locale(this.$store.getters.user.language)
          }
        } else {
          this.$store.getters.user.language("nl")
        }*/
  },

  methods: {}
};
</script>

<style lang="scss"></style>
